import React from "react";

type Props = {};

const InterestPaidPreConstructionHint: React.FC<Props> = (props: Props) => {
  return (
    <>
      <ul className="text-start text-greyDark leading-para">
        <li>
          Pre-construction period interest can be claimed only after the construction is completed
          and occupancy certificate is obtained.
        </li>
        <li>
          The deduction for such interest can be claimed in the ITR in five equal installments
          starting from the year in which the construction is completed.
        </li>
        <li>
          In this field you should enter the total pre construction period interest of all the years
          and Cleartax will automatically calculate and apply the deduction, which will be 1/5th of
          the total amount.
        </li>
      </ul>
    </>
  );
};

export default InterestPaidPreConstructionHint;
